import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_GATEWAY_URL,
});

// ... imports ...

api.interceptors.request.use(
  (config) => {
    const oidcKey = Object.keys(sessionStorage).find(key => key.startsWith('oidc.user'));

    if (oidcKey) {
      try {
        const user = JSON.parse(sessionStorage.getItem(oidcKey));

        // CAMBIO CLAVE 1: Preferimos id_token (coincide con tu test de consola)
        const token = user.id_token || user.access_token;

        if (token) {
            // CAMBIO CLAVE 2: Quitamos "Bearer " (AWS lo espera crudo si no hay Regex configurado)
            config.headers.Authorization = token;
            console.log("✅ [API] Token inyectado (Sin prefijo Bearer).");
        }
      } catch (e) {
        console.error("❌ [API] Error token:", e);
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default api;
